import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dataForm",
  style: {"margin-left":"0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_ctx.detail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "form-title mb-10 mt-10" }, [
          _createElementVNode("span", { class: "label green" }, "物"),
          _createElementVNode("span", { class: "left" }, "物料基本信息")
        ], -1)),
        _createVNode(_component_el_descriptions, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "物料编号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.no), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "物料名称：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "物料类别：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.materialClass), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "物料单位：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.materialUnit), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "封装规格：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.materialStandard), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "型号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.model), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}